var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personal-info ctsform" },
    [
      !_vm.accountSummaryFlow
        ? [
            _c(
              "div",
              {
                class: [
                  "strong-auth",
                  { "auth-enabled": _vm.isAuthServerEnabled }
                ]
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeStrongAuthyDialog()
                      }
                    }
                  },
                  [_vm._v("close")]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "strong-auth__title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Account.SecuritySettings.StrongAuthentication")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "strong-auth__methods" },
                  [
                    !_vm.hidePreferences
                      ? _c("span", { staticClass: "methods-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.SecuritySettings.StrongAuthentication.ChooseMethod"
                              )
                            )
                          )
                        ])
                      : _c("span", { staticClass: "methods-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.SecuritySettings.StrongAuthentication.ChooseMethod.PostRegistration"
                              )
                            )
                          )
                        ]),
                    _vm._v(" "),
                    _vm._l(_vm.twoFactorAuthChannelsOrder, function(channel) {
                      return _c(
                        "div",
                        { key: channel },
                        [
                          _vm.totpIsActive &&
                          channel.toUpperCase() === "AUTHENTICATOR"
                            ? [
                                _vm.totpShowStatus
                                  ? _c(
                                      "div",
                                      { staticClass: "methods-verified" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__title"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__title--child",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setTotpStatus(
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "piitem-arrow"
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_left")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.Title"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__status"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__status--child"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.CurrentStatus"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "badge-active"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.Active"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.totpShowStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "methods-verify",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.isTotpVerified
                                              ? _vm.setTotpStatus(true)
                                              : _vm.toggleTOTPVerify("open")
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.SecuritySettings.StrongAuthentication.Authenticator.Title"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "piitem-arrow" },
                                          [
                                            _c("v-icon", [
                                              _vm._v("chevron_right")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isPhoneChannelEligibleFor2FA &&
                          channel.toUpperCase() === "PHONE"
                            ? [
                                _vm.phoneShowStatus
                                  ? _c(
                                      "div",
                                      { staticClass: "methods-verified" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__title"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__title--child",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setPhoneStatus(
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "piitem-arrow"
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_left")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.Title"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__status"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__status--child"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.CurrentStatus"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "badge-active"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.Active"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.phoneShowStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "methods-verify",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.isPhoneVerified
                                              ? _vm.setPhoneStatus(true)
                                              : _vm.togglePhoneVerify("open")
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.SecuritySettings.StrongAuthentication.Phone.Title"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "piitem-arrow" },
                                          [
                                            _c("v-icon", [
                                              _vm._v("chevron_right")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEmailChannelEligibleFor2FA &&
                          channel.toUpperCase() === "EMAIL"
                            ? [
                                _vm.emailShowStatus
                                  ? _c(
                                      "div",
                                      { staticClass: "methods-verified" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__title"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__title--child",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setEmailStatus(
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "piitem-arrow"
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("chevron_left")
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.Title"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "methods-verified__status"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "methods-verified__status--child"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.CurrentStatus"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "badge-active"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.Active"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.emailShowStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "methods-verify",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.isEmailVerified
                                              ? _vm.setEmailStatus(true)
                                              : _vm.toggleEmailVerify("open")
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.SecuritySettings.StrongAuthentication.Email.Title"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "piitem-arrow" },
                                          [
                                            _c("v-icon", [
                                              _vm._v("chevron_right")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _c("br"),
                _vm._v(" "),
                !_vm.hidePreferences
                  ? _c("div", [
                      _vm.allowedSATypes &&
                      _vm.allowedSATypes.length > 0 &&
                      _vm.personalDetails &&
                      ((_vm.isPhoneVerified &&
                        _vm.isPhoneChannelEligibleFor2FA) ||
                        (_vm.isEmailVerified &&
                          _vm.isEmailChannelEligibleFor2FA) ||
                        (_vm.totpIsActive && _vm.isTotpVerified))
                        ? _c("div", [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.SecuritySettings.StrongAuthentication"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control-block pseudofilled auth-recovery",
                                class: { filled: _vm.useSA4AccountRecovery }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.useSA4AccountRecovery,
                                        expression: "useSA4AccountRecovery"
                                      }
                                    ],
                                    staticClass: "input-field dd-menu",
                                    attrs: {
                                      autocomplete: "off",
                                      id: "useSA4AccountRecovery"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.useSA4AccountRecovery = $event
                                          .target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "NO_SA",
                                          selected: "selected"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(_vm.NoSAAccRecoveryLabel)
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.allowedSATypes, function(
                                      saType
                                    ) {
                                      return _vm.shouldBeShown(
                                        saType.mode,
                                        "sa4AccountRecovery"
                                      )
                                        ? _c(
                                            "option",
                                            {
                                              domProps: { value: saType.value }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.PersonalDetails.SA.Mode" +
                                                      saType.mode
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.PersonalDetails.UseSA4AccountRecovery"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control-block pseudofilled auth-login",
                                class: { filled: _vm.useSA4UserLogin }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.useSA4UserLogin,
                                        expression: "useSA4UserLogin"
                                      }
                                    ],
                                    staticClass: "input-field dd-menu",
                                    attrs: {
                                      autocomplete: "off",
                                      id: "useSA4UserLogin"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.useSA4UserLogin = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "NO_SA",
                                          selected: "selected"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.PersonalDetails.UserPreferences.NoStrongAuthentication"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.allowedSATypes, function(
                                      saType
                                    ) {
                                      return _vm.shouldBeShown(
                                        saType.mode,
                                        "sa4UserLogin"
                                      )
                                        ? _c(
                                            "option",
                                            {
                                              domProps: { value: saType.value }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.PersonalDetails.SA.Mode" +
                                                      saType.mode
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.PersonalDetails.UseSA4UserLogin"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-actions" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "success",
                                      disabled: !_vm.allowAccountUpdate,
                                      "x-large": "",
                                      id: "btn_save"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.save()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("Account.Save")))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.accountSummaryFlow
        ? [
            _c(
              "div",
              {
                class: [
                  "strong-auth",
                  { "auth-enabled": _vm.isAuthServerEnabled }
                ]
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeStrongAuthyDialog()
                      }
                    }
                  },
                  [_vm._v("close")]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "strong-auth__title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Account.SecuritySettings.StrongAuthentication")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  !_vm.isAuthServerEnabled
                    ? _c(
                        "div",
                        { staticClass: "strong-auth__methods" },
                        [
                          !_vm.hidePreferences
                            ? _c("span", { staticClass: "methods-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.SecuritySettings.StrongAuthentication.ChooseMethod"
                                    )
                                  )
                                )
                              ])
                            : _vm.hidePreferences && _vm.totpIsActive
                            ? _c("span", { staticClass: "methods-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.SecuritySettings.StrongAuthentication.ChooseMethod.PostRegistration"
                                    )
                                  )
                                )
                              ])
                            : _vm.hidePreferences && !_vm.totpIsActive
                            ? _c("span", { staticClass: "methods-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.SecuritySettings.StrongAuthentication.ChooseMethod.PostRegistration.OnlyPhone"
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.twoFactorAuthChannelsOrder, function(
                            channel
                          ) {
                            return _c(
                              "div",
                              { key: channel },
                              [
                                _vm.totpIsActive &&
                                channel.toUpperCase() === "AUTHENTICATOR"
                                  ? [
                                      _vm.totpShowStatus
                                        ? _c(
                                            "div",
                                            { staticClass: "methods-verified" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__title"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__title--child",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.setTotpStatus(
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "piitem-arrow"
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_left"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.Title"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__status"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__status--child"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.CurrentStatus"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge-active"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.SecuritySettings.StrongAuthentication.Authenticator.Status.Active"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.totpShowStatus
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "methods-verify",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.isTotpVerified
                                                    ? _vm.setTotpStatus(true)
                                                    : _vm.toggleTOTPVerify(
                                                        "open"
                                                      )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Account.SecuritySettings.StrongAuthentication.Authenticator.Title"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "piitem-arrow" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("chevron_right")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isPhoneChannelEligibleFor2FA &&
                                channel.toUpperCase() === "PHONE"
                                  ? [
                                      _vm.phoneShowStatus
                                        ? _c(
                                            "div",
                                            { staticClass: "methods-verified" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__title"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__title--child",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.setPhoneStatus(
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "piitem-arrow"
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_left"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.Title"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__status"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__status--child"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.CurrentStatus"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge-active"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.SecuritySettings.StrongAuthentication.Authenticator.Phone.Active"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.phoneShowStatus
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "methods-verify",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.isPhoneVerified
                                                    ? _vm.setPhoneStatus(true)
                                                    : _vm.togglePhoneVerify(
                                                        "open"
                                                      )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Account.SecuritySettings.StrongAuthentication.Phone.Title"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "piitem-arrow" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("chevron_right")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isEmailChannelEligibleFor2FA &&
                                channel.toUpperCase() === "EMAIL"
                                  ? [
                                      _vm.emailShowStatus
                                        ? _c(
                                            "div",
                                            { staticClass: "methods-verified" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__title"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__title--child",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.setEmailStatus(
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "piitem-arrow"
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "chevron_left"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.Title"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "methods-verified__status"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "methods-verified__status--child"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.CurrentStatus"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge-active"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.SecuritySettings.StrongAuthentication.Authenticator.Email.Active"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.emailShowStatus
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "methods-verify",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.isEmailVerified
                                                    ? _vm.setEmailStatus(true)
                                                    : _vm.toggleEmailVerify(
                                                        "open"
                                                      )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Account.SecuritySettings.StrongAuthentication.Email.Title"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "piitem-arrow" },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("chevron_right")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  !_vm.hidePreferences
                    ? _c("div", [
                        _vm.allowedSATypes &&
                        _vm.allowedSATypes.length > 0 &&
                        _vm.personalDetails &&
                        ((_vm.isPhoneVerified &&
                          _vm.isPhoneChannelEligibleFor2FA) ||
                          (_vm.isEmailVerified &&
                            _vm.isEmailChannelEligibleFor2FA) ||
                          (_vm.totpIsActive && _vm.isTotpVerified) ||
                          _vm.isAuthServerEnabled)
                          ? _c(
                              "div",
                              [
                                _vm.brandTemplate !== "generic_2"
                                  ? [
                                      !_vm.isAuthServerEnabled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block pseudofilled auth-recovery not-inline",
                                              class: {
                                                filled:
                                                  _vm.useSA4AccountRecovery
                                              }
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.useSA4AccountRecovery,
                                                      expression:
                                                        "useSA4AccountRecovery"
                                                    }
                                                  ],
                                                  ref:
                                                    "SA4AccountRecoveryDisabled",
                                                  staticClass:
                                                    "input-field dd-menu",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    id: "useSA4AccountRecovery"
                                                  },
                                                  on: {
                                                    change: [
                                                      function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.useSA4AccountRecovery = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      },
                                                      _vm.selectChange
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "NO_SA",
                                                        selected: "selected"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.NoSAAccRecoveryLabel
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.allowedSATypes,
                                                    function(saType) {
                                                      return _vm.shouldBeShown(
                                                        saType.mode,
                                                        "sa4AccountRecovery"
                                                      )
                                                        ? _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  saType.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Account.PersonalDetails.SA.Mode" +
                                                                      saType.mode
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "control-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.PersonalDetails.UseSA4AccountRecovery"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "auth-recovery__piitem-arrow"
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("expand_more")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isAuthServerEnabled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block pseudofilled auth-login not-inline",
                                              class: {
                                                filled: _vm.useSA4UserLogin
                                              }
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.useSA4UserLogin,
                                                      expression:
                                                        "useSA4UserLogin"
                                                    }
                                                  ],
                                                  ref: "SA4UserLoginDisabled",
                                                  staticClass:
                                                    "input-field dd-menu",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    id: "useSA4UserLogin"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.useSA4UserLogin = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "NO_SA",
                                                        selected: "selected"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Account.PersonalDetails.UserPreferences.NoStrongAuthentication"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.allowedSATypes,
                                                    function(saType) {
                                                      return _vm.shouldBeShown(
                                                        saType.mode,
                                                        "sa4UserLogin"
                                                      )
                                                        ? _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value:
                                                                  saType.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Account.PersonalDetails.SA.Mode" +
                                                                      saType.mode
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "control-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.PersonalDetails.UseSA4UserLogin"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "auth-login__piitem-arrow"
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("expand_more")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brandTemplate === "generic_2"
                                  ? [
                                      !_vm.isAuthServerEnabled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block-columns"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.PersonalDetails.UseSA4AccountRecovery"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "control-block pseudofilled auth-recovery not-inline",
                                                  class: {
                                                    filled:
                                                      _vm.useSA4AccountRecovery
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.useSA4AccountRecovery,
                                                          expression:
                                                            "useSA4AccountRecovery"
                                                        }
                                                      ],
                                                      ref:
                                                        "SA4AccountRecoveryDisabled",
                                                      staticClass:
                                                        "input-field dd-menu",
                                                      attrs: {
                                                        autocomplete: "off",
                                                        id:
                                                          "useSA4AccountRecovery"
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.useSA4AccountRecovery = $event
                                                              .target.multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          },
                                                          _vm.selectChange
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "NO_SA",
                                                            selected: "selected"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                _vm.NoSAAccRecoveryLabel
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.allowedSATypes,
                                                        function(saType) {
                                                          return _vm.shouldBeShown(
                                                            saType.mode,
                                                            "sa4AccountRecovery"
                                                          )
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value:
                                                                      saType.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Account.PersonalDetails.SA.Mode" +
                                                                          saType.mode
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "auth-recovery__piitem-arrow"
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("expand_more")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isAuthServerEnabled
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control-block-columns"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Account.PersonalDetails.UseSA4UserLogin"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "control-block pseudofilled auth-login not-inline",
                                                  class: {
                                                    filled: _vm.useSA4UserLogin
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.useSA4UserLogin,
                                                          expression:
                                                            "useSA4UserLogin"
                                                        }
                                                      ],
                                                      ref:
                                                        "SA4UserLoginDisabled",
                                                      staticClass:
                                                        "input-field dd-menu",
                                                      attrs: {
                                                        autocomplete: "off",
                                                        id: "useSA4UserLogin"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.useSA4UserLogin = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "NO_SA",
                                                            selected: "selected"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.PersonalDetails.UserPreferences.NoStrongAuthentication"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.allowedSATypes,
                                                        function(saType) {
                                                          return _vm.shouldBeShown(
                                                            saType.mode,
                                                            "sa4UserLogin"
                                                          )
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value:
                                                                      saType.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Account.PersonalDetails.SA.Mode" +
                                                                          saType.mode
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "auth-login__piitem-arrow"
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("expand_more")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isAuthServerEnabled
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "control-block pseudofilled auth-login auth-server-login not-inline",
                                        class: { filled: _vm.useSA4UserLogin }
                                      },
                                      [
                                        _c(
                                          "h1",
                                          { staticClass: "auth-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.SecuritySettings.StrongAuthentication.Title"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "auth-block require-2fa",
                                            attrs: {
                                              "justify-space-between": "",
                                              "align-center": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "wrap",
                                                attrs: { "align-center": "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "checkbox",
                                                      {
                                                        "two-factor-enabled":
                                                          _vm.isAuth2FaSystemEnabled
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isAuth2FaSystemEnabled
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.checkboxChange
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.multiFactorAuthentication,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.multiFactorAuthentication = $$v
                                                        },
                                                        expression:
                                                          "multiFactorAuthentication"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "control-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.PersonalDetails.UseSA4UserLogin.AuthServer"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.isAuthServerEnabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-actions"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "success",
                                                          disabled:
                                                            !_vm.allowAccountUpdate ||
                                                            (!_vm.selectedChange &&
                                                              !_vm.checkBoxClicked),
                                                          "x-large": "",
                                                          id: "btn_save"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.save()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.Save"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h1",
                                          { staticClass: "auth-title move" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.PersonalDetails.UseSA4UserLogin.Title"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pair-auth auth-block"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "pair-wrapper" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "pair-span" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Account.PersonalDetails.UseSA4UserLogin.PairAuthenticator"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.isTotpVerified
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pair-status color-blue"
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.PairAuthenticator.Status.Paired"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-status icon-paired"
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pair-status color-red"
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.PairAuthenticator.Status.NotPaired"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-status icon-not-paired"
                                                        })
                                                      ]
                                                    )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn theme--light success",
                                                attrs: { "x-large": "" },
                                                on: {
                                                  click: _vm.pairAuthenticator
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-btn__content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isTotpVerified
                                                            ? _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.Pair.Again"
                                                              )
                                                            : _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.Pair"
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isTotpVerified
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pair-auth-disclaimer"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Account.PersonalDetails.UseSA4UserLogin.PairAuthenticator.Disclaimer"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isAuthServerEnabled
                                  ? _c(
                                      "div",
                                      { staticClass: "form-actions" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              disabled: !_vm.allowAccountUpdate,
                                              "x-large": "",
                                              id: "btn_save"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.save()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Account.Save"))
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isAuthServerEnabled
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "control-block pseudofilled auth-login auth-server-login not-inline codes-generate",
                                        class: { filled: _vm.useSA4UserLogin }
                                      },
                                      [
                                        _c(
                                          "h1",
                                          { staticClass: "auth-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.Title"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pair-auth auth-block"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "pair-wrapper" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "codes-generated"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.recoveryCodesNotGenerated
                                                          ? _vm.$t(
                                                              "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.Generated"
                                                            )
                                                          : _vm.$t(
                                                              "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.NotGenerated"
                                                            )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                !_vm.recoveryCodesNotGenerated
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pair-status color-blue"
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.Generated.Disclaimer"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-status icon-paired"
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pair-status color-red"
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.NotGenerated.Disclaimer"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "icon-status icon-not-paired"
                                                        })
                                                      ]
                                                    )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "v-btn theme--light success",
                                                attrs: { "x-large": "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.generateCodes()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-btn__content"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.recoveryCodesNotGenerated
                                                            ? _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.GenerateCodes"
                                                              )
                                                            : _vm.$t(
                                                                "Account.PersonalDetails.UseSA4UserLogin.RecoveryCodes.RegenerateCodes"
                                                              )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "close",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.$store.commit("setIs2FA", true)
                              }
                            }
                          },
                          [_vm._v("close")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.get2fa()
                              }
                            }
                          },
                          [_vm._v("close dialog and show login")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm.totpVerifyPopup
          ? _c("div", { staticClass: "tandc-popup-container" }, [
              _c(
                "div",
                { staticClass: "authy-popup-child" },
                [
                  _c("AccountAuthentication", {
                    on: {
                      declineToggleTOTPVerify: function($event) {
                        return _vm.toggleTOTPVerify("decline")
                      }
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.phoneVerifyPopup
          ? _c("div", { staticClass: "tandc-popup-container" }, [
              _c("div", { staticClass: "authy-popup-child" }, [
                _c(
                  "div",
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.togglePhoneVerify("decline")
                          }
                        }
                      },
                      [_vm._v("close")]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "authy-popup-child-content" },
                      [
                        _c("div", { staticClass: "titles" }, [
                          _c("p", { staticClass: "guidedTitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Authentication.2fa.Authentication"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Authentication.2fa.AuthenticationByPhone"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        !_vm.changePhoneVisible
                          ? _c("verify-by-pin", {
                              attrs: {
                                page: "verify_mob",
                                state: "sent",
                                fromVerDetail: true
                              },
                              on: {
                                changeDetailPhone: _vm.changeDetailPhone,
                                refreshafteraction: _vm.updateAuthyStatus
                              }
                            })
                          : _c("change-detail", {
                              attrs: { page: "verify_mob" },
                              on: { goBackPhone: _vm.changeDetailPhone }
                            })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.emailVerifyPopup
          ? _c("div", { staticClass: "tandc-popup-container" }, [
              _c("div", { staticClass: "authy-popup-child" }, [
                _c(
                  "div",
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleEmailVerify("decline")
                          }
                        }
                      },
                      [_vm._v("close")]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "authy-popup-child-content" },
                      [
                        _c("div", { staticClass: "titles" }, [
                          _c("p", { staticClass: "guidedTitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Authentication.2fa.Authentication"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.Authentication.2fa.AuthenticationByEmail"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        !_vm.changeEmailVisible
                          ? _c("verify-by-pin", {
                              attrs: {
                                page: "verify_email",
                                state: "sent",
                                fromVerDetail: true
                              },
                              on: {
                                changeDetailEmail: _vm.changeDetailEmail,
                                refreshafteraction: _vm.updateAuthyStatus
                              }
                            })
                          : _c("change-detail", {
                              attrs: { page: "verify_email" },
                              on: { goBackEmail: _vm.changeDetailEmail }
                            })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle:
              _vm.processingTitle ||
              _vm.$t("Account.PersonalDetails.Dialog.Processing.Title"),
            processingText:
              _vm.processingText ||
              _vm.$t("Account.PersonalDetails.Dialog.Processing.Text"),
            successTitle:
              _vm.successTitle ||
              _vm.$t("Account.SecuritySettings.Dialog.Success.Title"),
            successText:
              _vm.successText ||
              _vm.$t("Account.PersonalDetails.Dialog.Success.Text"),
            errorTitle:
              _vm.errorTitle ||
              _vm.$t("Account.SecuritySettings.Dialog.Error.Title"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.PersonalDetails.Dialog.Error.Text")
                        )
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "response-error" }, [
              _vm._v(_vm._s(_vm.transactionError))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.PersonalDetails.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587296c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587296c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/SecuritySettings.vue
// module id = null
// module chunks = 